class PuzzleGame {
  constructor(section) {
    this.section = section;

    this.board = section.querySelector('[data-puzzle-board]');
    this.levelEl = section.querySelector('[data-puzzle-level]');
    this.piecesEl = section.querySelector('[data-puzzle-pieces]');
    this.timerEl = section.querySelector('[data-puzzle-timer]');

    this.startButton = section.querySelector('[data-puzzle-start]');
    this.restartButton = section.querySelector('[data-puzzle-restart]');
    this.playAgainButton = section.querySelector(
      '[data-puzzle-play-again]'
    );

    this.downloadVoucherButton = section.querySelector(
      '[data-puzzle-download-voucher]'
    );

    this.popup = section.querySelector('[data-puzzle-popup]');
    this.popupTitle = section.querySelector(
      '[data-puzzle-popup-title]'
    );
    this.popupText = section.querySelector(
      '[data-puzzle-popup-text]'
    );
    this.popupIcon = section.querySelector(
      '[data-puzzle-popup-icon]'
    );

    this.popupCloseButtons = section.querySelectorAll(
      '[data-puzzle-popup-close]'
    );

    this.rewardWrapper = section.querySelector(
      '[data-puzzle-reward-wrapper]'
    );
    this.rewardCodeEl = section.querySelector(
      '[data-puzzle-reward]'
    );
    this.copyButton = section.querySelector(
      '[data-puzzle-copy]'
    );

    this.levelMessage = section.querySelector(
      '[data-puzzle-level-message]'
    );
    this.levelMessageTitle = section.querySelector(
      '[data-puzzle-level-message-title]'
    );
    this.levelMessageText = section.querySelector(
      '[data-puzzle-level-message-text]'
    );

    this.statusEl = section.querySelector(
      '[data-puzzle-status]'
    );

    this.confettiContainer = section.querySelector(
      '[data-puzzle-confetti]'
    );

    this.image = section.dataset.image || '';
    this.sectionId = section.dataset.sectionId || 'puzzle';

    this.rewardEndpoint =
      section.dataset.rewardEndpoint || '';

    this.levelLabel =
      section.dataset.levelLabel || 'Level';

    this.startingText =
      section.dataset.startingText ||
      'The game has started.';

    this.levelCompleteTitle =
      section.dataset.levelCompleteTitle ||
      'Level Complete!';

    this.levelCompleteText =
      section.dataset.levelCompleteText ||
      'Great job! Get ready for the final level.';

    this.winTitle =
      section.dataset.winTitle || 'You Won!';

    this.winText =
      section.dataset.winText ||
      'You completed both levels. Your reward code is ready.';

    this.loseTitle =
      section.dataset.loseTitle || 'Time’s Up!';

    this.loseText =
      section.dataset.loseText ||
      'Try again and complete the puzzle before the timer ends.';

    this.noCodeTitle =
      section.dataset.noCodeTitle ||
      'Reward Unavailable';

    this.noCodeText =
      section.dataset.noCodeText ||
      'No reward codes are currently available.';

    this.levels = [
      {
        level: 1,
        pieces: 8,
        columns: 4,
        rows: 2,
        time: this.getValidNumber(
          section.dataset.levelOneTime,
          60
        )
      },
      {
        level: 2,
        pieces: 16,
        columns: 4,
        rows: 4,
        time: this.getValidNumber(
          section.dataset.levelTwoTime,
          90
        )
      }
    ];

    this.currentLevelIndex = 0;
    this.selectedPiece = null;

    this.timerId = null;
    this.transitionTimeoutId = null;
    this.popupTimeoutId = null;
    this.confettiTimeoutId = null;

    this.timeLeft = 0;
    this.isPlaying = false;
    this.isTransitioning = false;
    this.isRequestingReward = false;

    this.currentRewardCode = '';

    this.boundKeydown = this.handleKeydown.bind(this);

    if (!this.board) {
      return;
    }

    this.showPreview();
    this.bindEvents();
  }

  getValidNumber(value, fallback) {
    const number = Number(value);

    if (!Number.isFinite(number) || number <= 0) {
      return fallback;
    }

    return Math.floor(number);
  }

  bindEvents() {
    if (this.startButton) {
      this.startButton.addEventListener('click', () => {
        this.startGame();
      });
    }

    if (this.restartButton) {
      this.restartButton.addEventListener('click', () => {
        this.startGame();
      });
    }

    if (this.playAgainButton) {
      this.playAgainButton.addEventListener('click', () => {
        this.startGame();
      });
    }

    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => {
        this.copyRewardCode();
      });
    }

if (this.downloadVoucherButton) {
  this.downloadVoucherButton.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      event.stopPropagation();

      this.downloadVoucher();
    }
  );
}

    this.popupCloseButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.closePopup();
      });
    });

    document.addEventListener(
      'keydown',
      this.boundKeydown
    );
  }

  handleKeydown(event) {
    if (
      event.key === 'Escape' &&
      this.popup &&
      this.popup.classList.contains('is-active')
    ) {
      this.closePopup();
    }
  }

  showPreview() {
    this.clearTimer();
    this.clearTransitionTimeout();

    this.isPlaying = false;
    this.isTransitioning = false;
    this.selectedPiece = null;

    this.board.innerHTML = '';
    this.board.classList.remove('is-playing');

    this.board.style.display = 'block';
    this.board.style.gridTemplateColumns = '';
    this.board.style.gridTemplateRows = '';

    if (this.image) {
      this.board.style.backgroundImage =
        `url("${this.image}")`;

      this.board.style.backgroundSize = 'cover';
      this.board.style.backgroundPosition = 'center';
      this.board.style.backgroundRepeat = 'no-repeat';
    } else {
      this.board.style.backgroundImage = '';
    }

    if (this.levelEl) {
      this.levelEl.textContent = '1 / 2';
    }

    if (this.piecesEl) {
      this.piecesEl.textContent = '8';
    }

    if (this.timerEl) {
      this.timerEl.textContent =
        this.formatTime(this.levels[0].time);

      this.timerEl.classList.remove(
        'is-running-out'
      );
    }

    if (this.startButton) {
      this.startButton.disabled = !this.image;
    }

    if (this.restartButton) {
      this.restartButton.disabled = true;
    }

    if (this.downloadVoucherButton) {
      this.downloadVoucherButton.hidden = true;
    }

    this.hideLevelMessage();
  }

  startGame() {
    if (!this.image) {
      window.alert(
        'Please select a puzzle image in the Shopify theme editor.'
      );
      return;
    }

    this.clearTimer();
    this.clearTransitionTimeout();
    this.clearConfetti();

    this.closePopup(true);
    this.hideLevelMessage();

    this.currentLevelIndex = 0;
    this.currentRewardCode = '';
    this.selectedPiece = null;

    this.isPlaying = false;
    this.isTransitioning = false;

    this.startLevel();
  }

  startLevel() {
    const level = this.levels[this.currentLevelIndex];

    if (!level) {
      return;
    }

    this.clearTimer();
    this.clearSelection();
    this.hideLevelMessage();

    this.isPlaying = true;
    this.isTransitioning = false;
    this.timeLeft = level.time;

    this.updateStats(level);
    this.createBoard(level);
    this.updateTimer();
    this.startTimer();

    if (this.startButton) {
      this.startButton.disabled = true;
    }

    if (this.restartButton) {
      this.restartButton.disabled = false;
    }

    this.announce(
      `${this.startingText} ${this.levelLabel} ${level.level}.`
    );
  }

  updateStats(level) {
    if (this.levelEl) {
      this.levelEl.textContent =
        `${level.level} / ${this.levels.length}`;
    }

    if (this.piecesEl) {
      this.piecesEl.textContent =
        String(level.pieces);
    }
  }

  createBoard(level) {
    this.board.innerHTML = '';
    this.board.classList.add('is-playing');

    this.board.style.display = 'grid';
    this.board.style.backgroundImage = '';
    this.board.style.backgroundSize = '';
    this.board.style.backgroundPosition = '';
    this.board.style.backgroundRepeat = '';

    this.board.style.gridTemplateColumns =
      `repeat(${level.columns}, minmax(0, 1fr))`;

    this.board.style.gridTemplateRows =
      `repeat(${level.rows}, minmax(0, 1fr))`;

    const shuffledOrder = this.createShuffledOrder(
      level.pieces
    );

    const fragment = document.createDocumentFragment();

    shuffledOrder.forEach((imageIndex, boardIndex) => {
      const piece = this.createPiece(
        imageIndex,
        boardIndex,
        level
      );

      fragment.appendChild(piece);
    });

    this.board.appendChild(fragment);
  }

  createPiece(imageIndex, boardIndex, level) {
    const piece = document.createElement('button');

    piece.type = 'button';
    piece.className = 'puzzle-piece';

    piece.dataset.imageIndex = String(imageIndex);
    piece.dataset.boardIndex = String(boardIndex);

    piece.setAttribute('aria-pressed', 'false');
    piece.setAttribute(
      'aria-label',
      `Puzzle position ${boardIndex + 1}`
    );

    const column = imageIndex % level.columns;
    const row = Math.floor(
      imageIndex / level.columns
    );

    const positionX =
      level.columns > 1
        ? (column / (level.columns - 1)) * 100
        : 0;

    const positionY =
      level.rows > 1
        ? (row / (level.rows - 1)) * 100
        : 0;

    piece.style.backgroundImage =
      `url("${this.image}")`;

    piece.style.backgroundSize =
      `${level.columns * 100}% ${level.rows * 100}%`;

    piece.style.backgroundPosition =
      `${positionX}% ${positionY}%`;

    piece.style.backgroundRepeat = 'no-repeat';

    piece.addEventListener('click', () => {
      this.selectPiece(piece);
    });

    return piece;
  }

  createShuffledOrder(pieceCount) {
    const order = Array.from(
      { length: pieceCount },
      (_, index) => index
    );

    let attempts = 0;

    do {
      for (
        let index = order.length - 1;
        index > 0;
        index--
      ) {
        const randomIndex = Math.floor(
          Math.random() * (index + 1)
        );

        [order[index], order[randomIndex]] = [
          order[randomIndex],
          order[index]
        ];
      }

      attempts += 1;
    } while (
      this.isOrderSolved(order) &&
      attempts < 20
    );

    if (
      this.isOrderSolved(order) &&
      order.length > 1
    ) {
      [order[0], order[1]] = [
        order[1],
        order[0]
      ];
    }

    return order;
  }

  isOrderSolved(order) {
    return order.every(
      (value, index) => value === index
    );
  }

  selectPiece(piece) {
    if (
      !this.isPlaying ||
      this.isTransitioning ||
      !piece
    ) {
      return;
    }

    if (!this.selectedPiece) {
      this.selectedPiece = piece;

      piece.classList.add('is-selected');
      piece.setAttribute('aria-pressed', 'true');

      this.announce(
        'Puzzle piece selected. Select another piece to swap.'
      );

      return;
    }

    if (this.selectedPiece === piece) {
      this.clearSelection();
      this.announce('Puzzle piece deselected.');
      return;
    }

    const firstPiece = this.selectedPiece;

    this.swapPieces(firstPiece, piece);
    this.clearSelection();

    if (this.checkWin()) {
      this.completeLevel();
    }
  }

  swapPieces(firstPiece, secondPiece) {
    const firstImageIndex =
      firstPiece.dataset.imageIndex;

    const firstBackgroundPosition =
      firstPiece.style.backgroundPosition;

    firstPiece.dataset.imageIndex =
      secondPiece.dataset.imageIndex;

    firstPiece.style.backgroundPosition =
      secondPiece.style.backgroundPosition;

    secondPiece.dataset.imageIndex =
      firstImageIndex;

    secondPiece.style.backgroundPosition =
      firstBackgroundPosition;

    if (typeof firstPiece.animate === 'function') {
      firstPiece.animate(
        [
          { transform: 'scale(0.94)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 180,
          easing: 'ease-out'
        }
      );

      secondPiece.animate(
        [
          { transform: 'scale(0.94)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 180,
          easing: 'ease-out'
        }
      );
    }
  }

  clearSelection() {
    if (!this.selectedPiece) {
      return;
    }

    this.selectedPiece.classList.remove(
      'is-selected'
    );

    this.selectedPiece.setAttribute(
      'aria-pressed',
      'false'
    );

    this.selectedPiece = null;
  }

  checkWin() {
    const pieces = Array.from(
      this.board.querySelectorAll('.puzzle-piece')
    );

    if (!pieces.length) {
      return false;
    }

    return pieces.every((piece, index) => {
      return (
        Number(piece.dataset.imageIndex) === index
      );
    });
  }

  completeLevel() {
    if (this.isTransitioning) {
      return;
    }

    this.clearTimer();
    this.clearSelection();

    this.isPlaying = false;
    this.isTransitioning = true;

    const level = this.levels[this.currentLevelIndex];

    this.announce(
      `${this.levelLabel} ${level.level} completed.`
    );

    const isFinalLevel =
      this.currentLevelIndex ===
      this.levels.length - 1;

    if (isFinalLevel) {
      this.finishGame();
      return;
    }

    this.showLevelCompleteMessage();

    this.transitionTimeoutId = window.setTimeout(
      () => {
        this.currentLevelIndex += 1;
        this.startLevel();
      },
      1800
    );
  }

  showLevelCompleteMessage() {
    if (!this.levelMessage) {
      return;
    }

    if (this.levelMessageTitle) {
      this.levelMessageTitle.textContent =
        this.levelCompleteTitle;
    }

    if (this.levelMessageText) {
      this.levelMessageText.textContent =
        this.levelCompleteText;
    }

    this.levelMessage.hidden = false;
  }

  hideLevelMessage() {
    if (this.levelMessage) {
      this.levelMessage.hidden = true;
    }
  }

  startTimer() {
    this.clearTimer();

    this.timerId = window.setInterval(() => {
      if (!this.isPlaying) {
        return;
      }

      this.timeLeft = Math.max(
        0,
        this.timeLeft - 1
      );

      this.updateTimer();

      if (this.timeLeft === 0) {
        this.handleTimeExpired();
      }
    }, 1000);
  }

  updateTimer() {
    if (!this.timerEl) {
      return;
    }

    this.timerEl.textContent =
      this.formatTime(this.timeLeft);

    this.timerEl.classList.toggle(
      'is-running-out',
      this.timeLeft > 0 &&
        this.timeLeft <= 10
    );
  }

  formatTime(totalSeconds) {
    const minutes = Math.floor(
      totalSeconds / 60
    );

    const seconds = totalSeconds % 60;

    return `${minutes}:${String(seconds).padStart(
      2,
      '0'
    )}`;
  }

  handleTimeExpired() {
    this.clearTimer();
    this.clearSelection();

    this.isPlaying = false;
    this.isTransitioning = false;

    if (this.startButton) {
      this.startButton.disabled = false;
    }

    this.showLosePopup();
  }

  async finishGame() {
    this.isPlaying = false;
    this.isTransitioning = true;

    this.hideLevelMessage();

    if (this.startButton) {
      this.startButton.disabled = false;
    }

    this.createConfetti();
    await this.showWinPopup();

    this.isTransitioning = false;
  }

  async showWinPopup() {
    this.setPopupLoadingState();
    this.openPopup();

    const rewardCode =
      await this.getRewardCode();

    if (!rewardCode) {
      this.showNoCodePopup();
      return;
    }

    this.currentRewardCode = rewardCode;

    if (this.popupIcon) {
      this.popupIcon.textContent = '✓';
    }

    if (this.popupTitle) {
      this.popupTitle.textContent =
        this.winTitle;
    }

    if (this.popupText) {
      this.popupText.textContent =
        this.winText;
    }

    if (this.rewardCodeEl) {
      this.rewardCodeEl.textContent =
        rewardCode;
    }

    if (this.rewardWrapper) {
      this.rewardWrapper.hidden = false;
    }

    if (this.copyButton) {
      this.copyButton.disabled = false;
    }

    if (this.downloadVoucherButton) {
      this.downloadVoucherButton.hidden = false;
      this.downloadVoucherButton.disabled = false;
    }

    this.announce(
      `You won. Your reward code is ${rewardCode}.`
    );
  }

  setPopupLoadingState() {
    if (this.popupIcon) {
      this.popupIcon.textContent = '…';
    }

    if (this.popupTitle) {
      this.popupTitle.textContent =
        'Preparing Your Reward';
    }

    if (this.popupText) {
      this.popupText.textContent =
        'Please wait while we prepare your reward code.';
    }

    if (this.rewardWrapper) {
      this.rewardWrapper.hidden = true;
    }

    if (this.copyButton) {
      this.copyButton.disabled = true;
    }

    if (this.downloadVoucherButton) {
      this.downloadVoucherButton.hidden = true;
      this.downloadVoucherButton.disabled = true;
    }
  }

  showLosePopup() {
    if (this.popupIcon) {
      this.popupIcon.textContent = '!';
    }

    if (this.popupTitle) {
      this.popupTitle.textContent =
        this.loseTitle;
    }

    if (this.popupText) {
      this.popupText.textContent =
        this.loseText;
    }

    if (this.rewardWrapper) {
      this.rewardWrapper.hidden = true;
    }

    if (this.downloadVoucherButton) {
      this.downloadVoucherButton.hidden = true;
    }

    this.openPopup();
    this.announce(this.loseTitle);
  }

  showNoCodePopup() {
    if (this.popupIcon) {
      this.popupIcon.textContent = '!';
    }

    if (this.popupTitle) {
      this.popupTitle.textContent =
        this.noCodeTitle;
    }

    if (this.popupText) {
      this.popupText.textContent =
        this.noCodeText;
    }

    if (this.rewardWrapper) {
      this.rewardWrapper.hidden = true;
    }

    if (this.downloadVoucherButton) {
      this.downloadVoucherButton.hidden = true;
    }

    this.announce(this.noCodeTitle);
  }

  generateRandomRewardCode() {
    const characters =
      'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

    let randomPart = '';

    if (
      window.crypto &&
      typeof window.crypto.getRandomValues === 'function'
    ) {
      const randomValues =
        new Uint32Array(8);

      window.crypto.getRandomValues(randomValues);

      randomValues.forEach((value) => {
        randomPart += characters[
          value % characters.length
        ];
      });
    } else {
      for (let index = 0; index < 8; index++) {
        randomPart += characters.charAt(
          Math.floor(
            Math.random() * characters.length
          )
        );
      }
    }

    return `WIN-${randomPart}`;
  }

  async getRewardCode() {
    const storedCode =
      this.getStoredRewardCode();

    if (storedCode) {
      return storedCode;
    }

    if (this.isRequestingReward) {
      return '';
    }

    this.isRequestingReward = true;

    try {
      let code = '';

      if (this.rewardEndpoint) {
        code = await this.requestRewardCode();
      } else {
        code = this.generateRandomRewardCode();
      }

      code = this.normaliseRewardCode(code);

      if (code) {
        this.storeRewardCode(code);
      }

      return code;
    } catch (error) {
      console.error(
        'Puzzle reward request failed:',
        error
      );

      const randomCode =
        this.generateRandomRewardCode();

      this.storeRewardCode(randomCode);

      return randomCode;
    } finally {
      this.isRequestingReward = false;
    }
  }

  async requestRewardCode() {
    const requestUrl = new URL(
      this.rewardEndpoint
    );

    requestUrl.searchParams.set(
      'game',
      'puzzle'
    );

    requestUrl.searchParams.set(
      'section_id',
      this.sectionId
    );

    requestUrl.searchParams.set(
      'timestamp',
      String(Date.now())
    );

    const response = await fetch(
      requestUrl.toString(),
      {
        method: 'GET',
        cache: 'no-store',
        redirect: 'follow'
      }
    );

    if (!response.ok) {
      throw new Error(
        `Reward server returned ${response.status}.`
      );
    }

    const responseText =
      await response.text();

    let data;

    try {
      data = JSON.parse(responseText);
    } catch (error) {
      return responseText.trim();
    }

    if (
      data.success === false ||
      data.available === false
    ) {
      return '';
    }

    return (
      data.code ||
      data.reward ||
      data.discount_code ||
      ''
    );
  }

  normaliseRewardCode(value) {
    if (typeof value !== 'string') {
      return '';
    }

    return value
      .trim()
      .replace(/\s+/g, '')
      .slice(0, 100);
  }

  getRewardStorageKey() {
    return `puzzle_reward_v2_${this.sectionId}`;
  }

  getStoredRewardCode() {
    try {
      return (
        window.localStorage.getItem(
          this.getRewardStorageKey()
        ) || ''
      );
    } catch (error) {
      return '';
    }
  }

  storeRewardCode(code) {
    try {
      window.localStorage.setItem(
        this.getRewardStorageKey(),
        code
      );
    } catch (error) {
      console.warn(
        'The reward code could not be saved in this browser.'
      );
    }
  }

  async copyRewardCode() {
    if (!this.currentRewardCode) {
      return;
    }

    const originalText =
      this.copyButton
        ? this.copyButton.textContent
        : 'Copy Code';

    try {
      if (
        navigator.clipboard &&
        window.isSecureContext
      ) {
        await navigator.clipboard.writeText(
          this.currentRewardCode
        );
      } else {
        this.copyWithFallback(
          this.currentRewardCode
        );
      }

      if (this.copyButton) {
        this.copyButton.textContent = 'Copied!';
      }

      this.announce('Reward code copied.');

      window.setTimeout(() => {
        if (this.copyButton) {
          this.copyButton.textContent =
            originalText;
        }
      }, 1600);
    } catch (error) {
      this.copyWithFallback(
        this.currentRewardCode
      );
    }
  }

  copyWithFallback(text) {
    const textarea =
      document.createElement('textarea');

    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);

    textarea.select();
    textarea.setSelectionRange(
      0,
      textarea.value.length
    );

    try {
      document.execCommand('copy');
    } catch (error) {
      window.prompt(
        'Copy your reward code:',
        text
      );
    }

    textarea.remove();
  }

  downloadVoucher() {
  if (!this.currentRewardCode) {
    console.warn('No reward code available to generate a voucher.');
    return;
  }

  try {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) {
      console.error('Could not get 2D canvas context.');
      return;
    }

    const width = 1200;
    const height = 700;

    canvas.width = width;
    canvas.height = height;

    const primaryColor = '#EB028C';
    const darkColor = '#171717';
    const mutedColor = '#6B6B6B';
    const lightPink = '#FFF0F8';

    context.fillStyle = '#FFFFFF';
    context.fillRect(0, 0, width, height);

    context.fillStyle = lightPink;
    context.fillRect(0, 0, width, 220);

    context.globalAlpha = 0.1;
    context.fillStyle = primaryColor;

    context.beginPath();
    context.arc(90, 65, 170, 0, Math.PI * 2);
    context.fill();

    context.beginPath();
    context.arc(width - 70, 130, 210, 0, Math.PI * 2);
    context.fill();

    context.globalAlpha = 1;

    context.fillStyle = primaryColor;
    context.beginPath();
    context.arc(width / 2, 135, 62, 0, Math.PI * 2);
    context.fill();

    context.strokeStyle = '#FFFFFF';
    context.lineWidth = 14;
    context.lineCap = 'round';
    context.lineJoin = 'round';

    context.beginPath();
    context.moveTo(width / 2 - 27, 137);
    context.lineTo(width / 2 - 7, 158);
    context.lineTo(width / 2 + 34, 109);
    context.stroke();

    context.textAlign = 'center';

    context.fillStyle = darkColor;
    context.font = '700 56px Arial, Helvetica, sans-serif';
    context.fillText('YOU WON!', width / 2, 305);

    context.fillStyle = mutedColor;
    context.font = '400 25px Arial, Helvetica, sans-serif';
    context.fillText('You completed both puzzle levels.', width / 2, 352);

    const boxX = 170;
    const boxY = 400;
    const boxWidth = 860;
    const boxHeight = 175;
    const radius = 28;

    context.fillStyle = lightPink;
    this.drawRoundedRectangle(context, boxX, boxY, boxWidth, boxHeight, radius);
    context.fill();

    context.strokeStyle = primaryColor;
    context.lineWidth = 3;
    context.setLineDash([12, 10]);
    this.drawRoundedRectangle(context, boxX, boxY, boxWidth, boxHeight, radius);
    context.stroke();
    context.setLineDash([]);

    context.fillStyle = mutedColor;
    context.font = '700 19px Arial, Helvetica, sans-serif';
    context.fillText('YOUR REWARD CODE', width / 2, 448);

    context.fillStyle = darkColor;
    context.font = '700 46px Arial, Helvetica, sans-serif';
    context.fillText(this.currentRewardCode, width / 2, 522);

    context.fillStyle = mutedColor;
    context.font = '400 19px Arial, Helvetica, sans-serif';
    context.fillText(
      'Use this code at checkout. Terms and conditions apply.',
      width / 2,
      640
    );

    // Use toBlob + object URL instead of toDataURL — far more
    // reliable across browsers (especially in-app browsers on iOS).
    canvas.toBlob((blob) => {
      if (!blob) {
        console.error('canvas.toBlob() returned null.');
        this.openVoucherFallback(canvas);
        return;
      }

      const blobUrl = URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');

      downloadLink.download = `puzzle-voucher-${this.currentRewardCode}.png`;
      downloadLink.href = blobUrl;
      downloadLink.rel = 'noopener';

      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();

      window.setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 1000);

      this.announce('Voucher downloaded.');
    }, 'image/png');
  } catch (error) {
    console.error('Voucher generation failed:', error);
  }
}

// Fallback for browsers (mainly iOS Safari / in-app browsers like
// Instagram/Facebook) that ignore the download attribute. Opens the
// image in a new tab so the user can long-press "Save Image".
openVoucherFallback(canvas) {
  try {
    const dataUrl = canvas.toDataURL('image/png');
    const newTab = window.open();

    if (newTab) {
      newTab.document.write(
        `<img src="${dataUrl}" alt="Voucher" style="max-width:100%;">`
      );
      newTab.document.title = 'Your Voucher';
    } else {
      window.alert(
        'Please allow pop-ups to view your voucher, or take a screenshot of your reward code.'
      );
    }
  } catch (error) {
    console.error('Voucher fallback failed:', error);
    window.alert(
      'Could not generate the voucher image. Please take a screenshot of your reward code instead.'
    );
  }
}

  drawRoundedRectangle(
    context,
    x,
    y,
    width,
    height,
    radius
  ) {
    const safeRadius = Math.min(
      radius,
      width / 2,
      height / 2
    );

    context.beginPath();

    context.moveTo(
      x + safeRadius,
      y
    );

    context.lineTo(
      x + width - safeRadius,
      y
    );

    context.quadraticCurveTo(
      x + width,
      y,
      x + width,
      y + safeRadius
    );

    context.lineTo(
      x + width,
      y + height - safeRadius
    );

    context.quadraticCurveTo(
      x + width,
      y + height,
      x + width - safeRadius,
      y + height
    );

    context.lineTo(
      x + safeRadius,
      y + height
    );

    context.quadraticCurveTo(
      x,
      y + height,
      x,
      y + height - safeRadius
    );

    context.lineTo(
      x,
      y + safeRadius
    );

    context.quadraticCurveTo(
      x,
      y,
      x + safeRadius,
      y
    );

    context.closePath();
  }

  openPopup() {
    if (!this.popup) {
      return;
    }

    window.clearTimeout(
      this.popupTimeoutId
    );

    this.popup.hidden = false;

    this.popup.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.classList.add(
      'puzzle-popup-open'
    );

    window.requestAnimationFrame(() => {
      this.popup.classList.add('is-active');
    });

    this.popupTimeoutId = window.setTimeout(
      () => {
        const focusTarget =
          this.popup.querySelector(
            'button:not([disabled]):not([hidden])'
          );

        if (focusTarget) {
          focusTarget.focus();
        }
      },
      250
    );
  }

  closePopup(immediate = false) {
    if (!this.popup) {
      return;
    }

    window.clearTimeout(
      this.popupTimeoutId
    );

    this.popup.classList.remove('is-active');

    this.popup.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement.classList.remove(
      'puzzle-popup-open'
    );

    const hidePopup = () => {
      if (
        !this.popup.classList.contains(
          'is-active'
        )
      ) {
        this.popup.hidden = true;
      }
    };

    if (immediate) {
      hidePopup();
    } else {
      this.popupTimeoutId =
        window.setTimeout(
          hidePopup,
          240
        );
    }
  }

  createConfetti() {
    if (!this.confettiContainer) {
      return;
    }

    this.clearConfetti();

    const colours = [
      '#EB028C',
      '#FFFFFF',
      '#FFD166',
      '#FF7ABF',
      '#171717'
    ];

    const pieceCount =
      window.innerWidth < 750 ? 55 : 90;

    const fragment =
      document.createDocumentFragment();

    for (
      let index = 0;
      index < pieceCount;
      index++
    ) {
      const confetti =
        document.createElement('span');

      confetti.className =
        'puzzle-confetti__piece';

      confetti.style.left =
        `${Math.random() * 100}%`;

      confetti.style.backgroundColor =
        colours[
          Math.floor(
            Math.random() * colours.length
          )
        ];

      confetti.style.setProperty(
        '--fall-duration',
        `${2.2 + Math.random() * 1.8}s`
      );

      confetti.style.setProperty(
        '--confetti-x',
        `${-100 + Math.random() * 200}px`
      );

      confetti.style.setProperty(
        '--confetti-rotation',
        `${360 + Math.random() * 1080}deg`
      );

      confetti.style.animationDelay =
        `${Math.random() * 0.8}s`;

      fragment.appendChild(confetti);
    }

    this.confettiContainer.appendChild(
      fragment
    );

    this.confettiTimeoutId =
      window.setTimeout(() => {
        this.clearConfetti();
      }, 5000);
  }

  clearConfetti() {
    window.clearTimeout(
      this.confettiTimeoutId
    );

    if (this.confettiContainer) {
      this.confettiContainer.innerHTML = '';
    }
  }

  clearTimer() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  clearTransitionTimeout() {
    if (this.transitionTimeoutId) {
      window.clearTimeout(
        this.transitionTimeoutId
      );

      this.transitionTimeoutId = null;
    }
  }

  announce(message) {
    if (!this.statusEl) {
      return;
    }

    this.statusEl.textContent = '';

    window.setTimeout(() => {
      this.statusEl.textContent = message;
    }, 40);
  }

  destroy() {
    this.clearTimer();
    this.clearTransitionTimeout();
    this.clearConfetti();

    window.clearTimeout(
      this.popupTimeoutId
    );

    document.removeEventListener(
      'keydown',
      this.boundKeydown
    );

    document.documentElement.classList.remove(
      'puzzle-popup-open'
    );
  }
}

function initialisePuzzleGames(container = document) {
  const games = container.matches?.(
    '[data-puzzle-game]'
  )
    ? [container]
    : container.querySelectorAll(
        '[data-puzzle-game]'
      );

  games.forEach((section) => {
    if (
      section.dataset.puzzleInitialised ===
      'true'
    ) {
      return;
    }

    section.dataset.puzzleInitialised =
      'true';

    section.puzzleGameInstance =
      new PuzzleGame(section);
  });
}

function startPuzzleInitialisation() {
  initialisePuzzleGames(document);
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    startPuzzleInitialisation,
    { once: true }
  );
} else {
  startPuzzleInitialisation();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initialisePuzzleGames(event.target);
  }
);

document.addEventListener(
  'shopify:section:unload',
  (event) => {
    const game =
      event.target.matches?.(
        '[data-puzzle-game]'
      )
        ? event.target
        : event.target.querySelector(
            '[data-puzzle-game]'
          );

    if (
      game &&
      game.puzzleGameInstance
    ) {
      game.puzzleGameInstance.destroy();
      delete game.puzzleGameInstance;
    }
  }
);